<template>
	<div class="language-selector">
		<button type="button" class="language-toggle" @click="dropdownOpen = !dropdownOpen" :aria-expanded="dropdownOpen">
			<span class="fi" :style="{ backgroundImage: 'url(' + currentLanguage.flag + ')' }"></span>
			<span class="language-name">{{ currentLanguage.name }}</span>
			<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 4.5L6 7.5L9 4.5"/></svg>
		</button>
		<ul class="language-dropdown" v-show="dropdownOpen">
			<li v-for="lang in languages"
			    :key="lang.code"
			    :class="{ active: $i18n.locale === lang.code }"
			    @click="changeLanguage(lang.code)">
				<span class="fi" :style="{ backgroundImage: 'url(' + lang.flag + ')' }"></span>
				<span>{{ lang.name }}</span>
			</li>
		</ul>
	</div>
</template>

<script>
// Only the two flags we need, the full flag-icons stylesheet would pull in every country
import flagNo from 'flag-icons/flags/4x3/no.svg'
import flagGb from 'flag-icons/flags/4x3/gb.svg'

export default {
	name: 'LanguageSelector',
	data() {
		return {
			dropdownOpen: false,
			languages: [
				{ code: 'no', name: 'Norsk', flag: flagNo },
				{ code: 'en', name: 'English', flag: flagGb }
			]
		}
	},
	computed: {
		currentLanguage() {
			return this.languages.find(l => l.code === this.$i18n.locale) || this.languages[1]
		}
	},
	methods: {
		changeLanguage(langCode) {
			this.$i18n.locale = langCode
			localStorage.setItem('language', langCode)
			this.dropdownOpen = false
		},
		closeDropdown(e) {
			if (!this.$el.contains(e.target)) {
				this.dropdownOpen = false
			}
		}
	},
	mounted() {
		document.addEventListener('click', this.closeDropdown)
	},
	beforeUnmount() {
		document.removeEventListener('click', this.closeDropdown)
	}
}
</script>

<style scoped>
.language-selector {
	position: relative;
}

.language-toggle {
	display: flex;
	align-items: center;
	gap: 8px;
	height: 36px;
	padding: 0 12px;
	border: 1px solid var(--color-border-card);
	border-radius: 8px;
	background: var(--color-bg-card);
	color: var(--color-text-muted);
	cursor: pointer;
	font-size: 13px;
	font-weight: 500;
	font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
	transition: border-color 0.15s, color 0.15s;
}

.language-toggle:hover {
	border-color: var(--color-border-card-hover);
	color: var(--color-text-primary);
}

.language-toggle svg {
	opacity: 0.7;
}

.fi {
	display: inline-block;
	width: 1.333333em;
	height: 1em;
	font-size: 16px;
	border-radius: 2px;
	background-size: contain;
	background-position: 50%;
	background-repeat: no-repeat;
}

.language-dropdown {
	position: absolute;
	top: 100%;
	right: 0;
	min-width: 150px;
	padding: 6px 0;
	margin: 6px 0 0 0;
	background: var(--color-bg-card);
	border: 1px solid var(--color-border-card);
	border-radius: 6px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
	list-style: none;
	z-index: 9999;
}

.language-dropdown li {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 10px 16px;
	margin: 0;
	cursor: pointer;
	font-size: 13px;
	font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
	color: var(--color-text-primary);
	transition: background-color 0.15s ease;
}

.language-dropdown li:hover {
	background-color: var(--color-bg-subtle);
}

.language-dropdown li.active {
	background-color: var(--color-accent-hover-bg);
	color: var(--color-accent);
}
</style>
